<template>
  <div id="app" class="min-h-screen bg-gray-50 font-sans">
    <MainLayout>
      <router-view />
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import {
  applyOrderLiveHeaderScript,
  removeOrderLiveHeaderScript
} from "@/helpers/headerScriptInjector";

export default {
  name: "App",
  components: {
    MainLayout
  },
  computed: {
    orderLiveHeaderScript() {
      const settings = this.$store.getters.getStore?.orderLiveSettings || {};
      return (
        settings.oo_headerscript ||
        settings.ooHeaderScript ||
        settings.ooHeaderscript ||
        ""
      );
    }
  },
  watch: {
    orderLiveHeaderScript: {
      handler(script) {
        applyOrderLiveHeaderScript(script);
      },
      immediate: true
    }
  },
  beforeDestroy() {
    removeOrderLiveHeaderScript();
  }
};
</script>

<style>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn-0-3s {
  animation: fadeIn 0.3s ease-out;
}
</style>
